import { IApplicationState } from '../types';

export const getUiState = (state: IApplicationState) => state.ui;
